import {ComplianceRiskEntry} from './compliance-risk-vergleichspaare';

export class ExportDetailErgebnis {
  funktionsebeneSAM: Funktionsebene;
  funktionsebeneNurGrundlohn: Funktionsebene;
  funktionsebeneFixeGewichtung: Funktionsebene;
  personenebeneSAM: Personenebene[];
  personenebeneNurGrundlohn: Personenebene[];
  personenebeneFixeGewichtung: Personenebene[];
}

export interface Funktionsebene {
  gesamtesUnternehmen: FunktionsebeneFixeGewichtungGesamtesUnternehmen;
  funktionenListe: FunktionenListe[];
}

export interface FunktionenListe {
  funktionId?: string;
  anzahlRisikopaareZuUngunstenMaenner?: number;
  anzahlMaennerMitTieferemLohn?: number;
  lohnunterschiedeZuUngunstenMaenner?: number;
  anzahlRisikopaareZuUngunstenFrauen?: number;
  anzahlFrauenMitTieferemLohn?: number;
  lohnunterschiedeZuUngunstenFrauen?: number;
  gesamtscoreOhneFunktion?: number;
  zuUngunstenFrauenOhneFunktion?: boolean;
  gesamtscoreNurFunktion?: number;
  zuUngunstenFrauenNurFunktion?: boolean;
}

export interface FunktionsebeneFixeGewichtungGesamtesUnternehmen {
  gesamtscore?: number;
  zuUngunstenDerFrauen?: boolean;
  anzahlRisikopaareZuUngunstenMaenner?: number;
  anzahlMaennerMitTieferemLohn?: number;
  lohnunterschiedeZuUngunstenMaenner?: number;
  anzahlRisikopaareZuUngunstenFrauen?: number;
  anzahlFrauenMitTieferemLohn?: number;
  lohnunterschiedeZuUngunstenFrauen?: number;
}

export class Personenebene extends ComplianceRiskEntry {
  lohnunterschiedInProzent?: string;
  funktionswertUnterschied?: number;
  p1Geschlecht?: Geschlecht;
  p2Geschlecht?: Geschlecht;
  lohnunterschied?: number;
}

export interface Funktionsliste {
  funktionId?: string;
  funktionswert?: number;
  funktionswertGrundlohn?: number;
  funktionswertFix?: number;
}

export enum Geschlecht {
  F = 'F',
  M = 'M'
}
